import { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../lib/api';
import { clearCachedCatalog } from '../lib/catalogCache';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('ss_token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp > Date.now() / 1000) setUser(payload);
        else localStorage.removeItem('ss_token');
      } catch { localStorage.removeItem('ss_token'); }
    }
    setLoading(false);
  }, []);

  async function loginAsUser(email, password) {
    const res = await api.loginAsUser(email, password);
    localStorage.setItem('ss_token', res.token);
    const payload = JSON.parse(atob(res.token.split('.')[1]));
    clearCachedCatalog();
    setUser(payload);
    return res;
  }

  function logout() {
    localStorage.removeItem('ss_token');
    clearCachedCatalog();
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, loading, loginAsUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
